module.exports = __webpack_public_path__ + "img/hyperx-cloud-orbit-preview.d799b3f4.png";